// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_nc-0";
export var animationContainer = "_nc-1";
export var itemPrice = "_nc-a";
export var itemizedContent = "_nc-9";
export var itemizedHeader = "_nc-7";
export var itemizedRow = "_nc-8";
export var itemizedSection = "_nc-6";
export var modalContent = "_nc-2";
export var orderName = "_nc-3";
export var refundOption = "_nc-4";
export var refundOptionsContainer = "_nc-5";
export var shippingLabel = "_nc-b";
export var totalRow = "_nc-c";